import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyDp2EEf9NRHQNs2W-U1toduB8wFbIjF5Og",
    authDomain: "market-b447f.firebaseapp.com",
    databaseURL: "https://market-b447f.firebaseio.com",
    projectId: "market-b447f",
    storageBucket: "gs://market-b447f.appspot.com",
    messagingSenderId: "610693936870",
    appId: "1:610693936870:web:0e7a4c2099f161eea06d27",
    measurementId: "G-FHQWLG3WT1"
};

export let fb = firebase.initializeApp(firebaseConfig);

export let firestore = fb.firestore();